import { ssData, useSSData } from "data/ss-store";

export function flagCheck(flag: string) {
  return !!ssData.featureFlags[flag];
}

export const useFlags = () => {
  const { featureFlags } = useSSData();
  return featureFlags;
};
